/**
 * Trunnion AI - Classification Banner
 * Top/bottom banners displaying the current classification level.
 */

import { useAuthStore } from '@/stores/authStore';
import { getClassificationBannerText, getClassificationCssKey } from '@/lib/classification';
import type { ClassificationLevel } from '@/types';

interface ClassificationBannerProps {
  level?: ClassificationLevel;
  position?: 'top' | 'bottom';
}

export function ClassificationBanner({ level, position = 'top' }: ClassificationBannerProps) {
  const { clearanceContext } = useAuthStore();
  const classificationLevel = level ?? clearanceContext?.sessionClassification ?? 'UNCLASSIFIED';
  const cssKey = getClassificationCssKey(classificationLevel);
  const bannerText = getClassificationBannerText(classificationLevel);

  return (
    <div
      className={`classification-banner classification-${cssKey} ${
        position === 'bottom' ? 'border-t' : 'border-b'
      } z-50 shrink-0`}
      role="banner"
      aria-label={`Classification level: ${bannerText}`}
    >
      {bannerText}
    </div>
  );
}
